import * as types from './types';
import { fetchGeneric } from 'State/generic/actions';

export const getLanguages = () => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.LANGUAGE_GETLANGUAGES,
        types.LANGUAGE_FETCHING,
        types.LANGUAGE_FETCH_ERROR,
        `Language`
      )
    );
  };
};

export const getLanguageFields = id => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.LANGUAGE_GETFIELDS,
        types.LANGUAGE_FETCHING,
        types.LANGUAGE_FETCH_ERROR,
        `Language/${id}`
      )
    );
  };
};

export const writeLanguageFields = fieldModel => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.LANGUAGE_SAVEFIELDS,
        types.LANGUAGE_FETCHING,
        types.LANGUAGE_FETCH_ERROR,
        `Language`,
        fieldModel
      )
    );
    dispatch({ type: types.LANGUAGE_SETSUCCESS });
  };
};

export const setLanguage = newLanguage => {
  return dispatch => {
    dispatch({ type: types.LANGUAGE_SETLANGUAGE, payload: newLanguage });
  };
};

export const resetSuccess = () => {
  return dispatch => {
    dispatch({ type: types.LANGUAGE_RESETSUCCESS });
  };
};



// WEBPACK FOOTER //
// ./src/pages/languagesetup/state/actions.js